export const BOARD_ACTIVE_VIEW_QUERY_PARAM = 'xpoBoardActiveView';
